up.compiler(".select_fresk_animation", function (element, data) {
  const freskId = element.dataset.defaultid;
  const selector = new Choices(element, {
    choices: data.map((e) => {
      let res = {
        value: e.id,
        label: e.title,
      };
      if (freskId && res.value.toString() === freskId) {
        res["selected"] = true;
      }
      return res;
    }),
    placeholder: true,
    placeholderValue: "Fresque",
    removeItemButton: true,
    classNames: {
      containerOuter: ["choices", "w-full"],
      containerInner: [
        "choices__inner",
        "text-base",
        "flex",
        "items-center",
        "justify-between",
        "rounded-md",
        "border",
        "border-input",
        "bg-white",
        "px-4",
        "text-base",
        "ring-offset-background",
        "focus:outline-none",
        "focus:ring-2",
        "focus:ring-ring",
        "focus:ring-offset-2",
        "disabled:cursor-not-allowed",
        "disabled:opacity-50",
        "[&>span]:line-clamp-1",
      ],
      input: ["choices__input"],
    },
  });
  // Force selector to its actual value
  selector.setChoiceByValue(parseInt(element.value, 10));
  if (!freskId) {
    selector.removeActiveItems();
  }

  return () => {
    selector.destroy();
  };
});
